"use strict";
'use client';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FormToggle = void 0;
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _react = _interopRequireWildcard(require("react"));
var _KeyboardDetectionContext = require("../../contexts/KeyboardDetectionContext.js");
var _dataEncoreIds = require("../../dataEncoreIds.js");
var _index = require("../../styles/index.js");
var _index2 = require("../VisuallyHidden/index.js");
var _Checkbox = require("./Checkbox.js");
var _Indicator = require("./Indicator.js");
var _Label = require("./Label.js");
var _Wrapper = require("./Wrapper.js");
var _excluded = ["small", "size", "children", "semanticColor", "isFocus", "isActive"];
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
/**
 * FormToggle allow users to switch the state of a single item on or off, within a Form component.
 *
 * [Storybook](https://encore-web.spotify.net/?path=/docs/components-formtoggle--docs) |
 * [Encore site](https://encore.spotify.net/web/components/selectors#toggle) |
 * [Github](https://ghe.spotify.net/encore/web/tree/master/src/core/components/FormToggle) |
 * [Figma](https://www.figma.com/design/bnQXqGkLeiTlbk8JXGDcsX/%E2%9A%99%EF%B8%8F-%E2%80%8A%E2%80%8BEncore-Web-Components?m=auto&node-id=32403-12302&t=ouXhP8WPuklpY62v-1)
 */
var FormToggle = exports.FormToggle = /*#__PURE__*/_react["default"].forwardRef(function FormToggle(_ref, ref) {
  var small = _ref.small,
    size = _ref.size,
    children = _ref.children,
    _ref$semanticColor = _ref.semanticColor,
    semanticColor = _ref$semanticColor === void 0 ? 'essentialBrightAccent' : _ref$semanticColor,
    isFocus = _ref.isFocus,
    isActive = _ref.isActive,
    props = (0, _objectWithoutProperties2["default"])(_ref, _excluded);
  var _useContext = (0, _react.useContext)(_KeyboardDetectionContext.KeyboardDetectionContext),
    isUsingKeyboard = _useContext.isUsingKeyboard;
  return /*#__PURE__*/_react["default"].createElement(_Checkbox.Checkbox, {
    "data-encore-id": _dataEncoreIds.ENCORE_DATA_IDS.FormToggle
  }, /*#__PURE__*/_react["default"].createElement(_index2.VisuallyHidden, Object.assign({
    component: "input",
    type: "checkbox",
    ref: ref
  }, props)), /*#__PURE__*/_react["default"].createElement(_Wrapper.Wrapper, {
    $isUsingKeyboard: isUsingKeyboard,
    $semanticColor: semanticColor,
    $isFocus: isFocus,
    $isActive: isActive
  }, /*#__PURE__*/_react["default"].createElement(_Indicator.Indicator, null)), children && /*#__PURE__*/_react["default"].createElement(_Label.Label, {
    className: small || size === 'small' ? (0, _index.textClass)('marginal') : (0, _index.textClass)('bodySmall')
  }, children));
});